import {
  enhanceWrapped,
  InputBase,
} from '../../../../../configure/components/InputBase';

const INPUT_LABEL =
  'Message to send when user fails form or quick question validation 3 times';
const INPUT_PLACEHOLDER = "Ok, let's skip that for now.";
const FIELD_TO_UPDATE = 'skipMessage';

const enhance = enhanceWrapped(FIELD_TO_UPDATE, INPUT_LABEL, INPUT_PLACEHOLDER);

const SkipMessage = enhance(InputBase);

export default SkipMessage;
